module.exports = __webpack_public_path__ + "img/body-3.9ed1708d.png";